import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const arrowDownSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" fill="none">
        <path stroke="currentColor" d="M14.5 21.5V6m0 15.5L11 18m3.5 3.5L18 18"></path>
    </svg>
)

const ArrowDownKeyboard: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {arrowDownSvg}
    </SvgIcon>
)

export default ArrowDownKeyboard